/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // =============================================
  // Auto-open order note accordion in cart drawer
  // =============================================
  function openOrderNote() {
    const details = document.querySelector('.cart__widget.accordion[data-collapsible]:not(.cart__widget--products)');
    if (!details) return;

    const body = details.querySelector('[data-collapsible-body]');

    details.setAttribute('open', 'true');
    if (body) body.style.height = 'auto';
  }

  const observer = new MutationObserver(function() {
    const details = document.querySelector('.cart__widget.accordion[data-collapsible]:not(.cart__widget--products)');
    if (details && !details.hasAttribute('open')) {
      setTimeout(openOrderNote, 100);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('theme:cart-drawer:open', function() {
    setTimeout(openOrderNote, 500);
  });

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(openOrderNote, 500);
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();